import React, { useEffect, useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "./TableTreeModal";
import Input from "../FormComponents/Input";
import Button from "../FormComponents/Button";
import MaterialIcon from "./MaterialIcon";
import { toastError } from "../../utils/toastUtils";

const FilterRenderer = ({ filters, updateFilters, tableId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const filterCallbackFunction = (data) => {
    const obj = filters.find((field) => field.id === data.id);
    if (obj) {
      toastError("Field already exists");
      return;
    }
    const newArr = [...filters];
    newArr.push({ ...data, is_multi_select: false });
    updateFilters(newArr);
  };

  return (
    <>
      <div>
        {tableId && (
          <Button variant="secondary" className="mb_2" onClick={() => setIsModalOpen(true)}>
            Add
          </Button>
        )}
        {filters?.map((filter, index) => (
          <SingleFilter key={filter.id} filter={filter} index={index} updateFilters={updateFilters} filters={filters} />
        ))}
      </div>
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName={"Add Filter"}>
        <TableTreeModal callbackFunction={filterCallbackFunction} tableId={tableId} />
      </BuilderModal>
    </>
  );
};

const SingleFilter = ({ filter, index, updateFilters, filters }) => {
  const [customFilter, setCustomFilter] = useState("");
  const [openFilter, setOpenFilter] = useState(false);

  const removeFilter = () => {
    let newArr = [...filters];
    newArr = newArr.filter((_, i) => i !== index);
    updateFilters(newArr);
  };

  const updateMultiFilter = (e) => {
    const { checked } = e.target;
    let newArr = [...filters];
    newArr[index].is_multi_select = checked;
    updateFilters(newArr);
  };

  const editFilter = (value) => {
    setCustomFilter(value);
    let newArr = [...filters];
    const editFilter = newArr[index];
    editFilter["custom_label"] = value;
    newArr[index] = editFilter;
    updateFilters(newArr);
  };

  useEffect(() => {
    setCustomFilter(filter.custom_label || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div key={index} className="Recordsview_column_list selected">
      <div>{filter.custom_label || filter.display}</div>
      {openFilter && <Input type="text" value={customFilter} onChange={(e) => editFilter(e.target.value)} />}

      <div className="d_flex gap_2">
        <div className="builder_checkbox_outer ">
          <Input onChange={updateMultiFilter} id="multi" type="checkbox" checked={filter?.is_multi_select || false} />
          <label htmlFor="multi">Multi Select Filter</label>
        </div>

        <MaterialIcon name="edit" onClick={() => setOpenFilter(!openFilter)} />

        <MaterialIcon name="remove" onClick={() => removeFilter()} />
      </div>
    </div>
  );
};

export { SingleFilter };
export default FilterRenderer;
